// @flow

import isNullOrUndefined from 'src/library/isNullOrUndefined'

export default function (value) {
	return isNullOrUndefined(value) || value === ''
}
